<script lang="ts">
    import SearchInput from '../../shared/SearchInput.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import { filter } from '../../../stores/filter';
    import { _ } from 'svelte-i18n';
    import Switch from '../../shared/Switch.svelte';
</script>

<div class="filter">
    <Switch bind:checked={$filter.planning.onlyNotReady} label="Only not ready" disabled={true} />
    <SearchInput
        query={$filter.planning.driverName}
        onChange={query => {
            $filter.planning.driverName = query;
        }}
        onKeyup={() => {}}
        placeholder={$_('Search by driver name')}
    />
</div>

<style>
    .filter {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 1rem;
        border: 1px solid var(--color-gray-300);
        border-radius: 0.5rem;
        column-gap: 10px;
        /*margin-bottom: 1rem;*/
    }
</style>
